<template>
  <vs-button
    v-tooltip="'Copiar'"
    color="primary"
    type="flat"
    icon-pack="feather"
    icon="icon-copy"
    class="d-inline items-center mt-5"
    @click="copyToClipboard()"
  ></vs-button>
</template>
<script>
import notify from '../utils/notify';

export default {
  name: 'copy-button',
  props: ['value'],
  methods: {
    copyToClipboard() {
      navigator.clipboard
        .writeText(this.value)
        .then(() => {
          notify.notifySuccess(
            this.$vs,
            'Copiado para a área de transferência.',
          );
        })
        .catch(() => {
          notify.notifyFail(this.$vs, 'Erro ao copiar');
        });
    },
  },
};
</script>
